import { useEffect, useRef } from 'react'

export const DeleteEarnedAccredButton = ({ id }) => {

  const modalInput = useRef(null)

  useEffect(() => { modalInput.current = document.querySelector('#delete-earned-accred-modal-value') }, [])

  const handleClick = () => { modalInput.current.value = id }

  return <span className="tf-button-danger" data-id={id} onClick={handleClick}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.0216 4.47623H4.97814C4.86162 4.47623 4.77241 4.57992 4.7898 4.69514L5.91109 12.1237C5.92515 12.2168 6.00522 12.2857 6.09943 12.2857H9.90031C9.99453 12.2857 10.0746 12.2168 10.0887 12.1237L11.21 4.69514C11.2273 4.57992 11.1381 4.47623 11.0216 4.47623ZM4.97814 3.33337C4.16249 3.33337 3.538 4.05919 3.65974 4.86571L4.78104 12.2943C4.87947 12.9464 5.43991 13.4286 6.09943 13.4286H9.90031C10.5598 13.4286 11.1203 12.9464 11.2187 12.2943L12.34 4.86571C12.4617 4.05919 11.8373 3.33337 11.0216 3.33337H4.97814Z" fill="currentColor"/>
      <rect x="2.66699" y="3.33337" width="10.6667" height="1.33333" fill="currentColor"/>
      <path d="M9.52418 3.33333C9.52418 3.33333 8.84195 3.33333 8.00037 3.33333C7.1588 3.33333 6.47656 3.33333 6.47656 3.33333C6.47656 2.49176 7.1588 1.80952 8.00037 1.80952C8.84195 1.80952 9.52418 2.49176 9.52418 3.33333Z" fill="currentColor"/>
    </svg>
  </span>
}
